import { AppData } from "../../AppDataProvider";
import i18n from "i18next";
import { isSupportedLanguageCode } from "../../../i18n";

/**
 * If this reducer is called, it means that the user is viewing the booking tool
 * is currently using a dialect of a supported language. We want to store a
 * reference to this dialect in the appData state so that the user can switch
 * back and forth between other languages and the dialect.
 */
export const detectedDialect = (options: { appData: AppData }): AppData => {
  return {
    ...options.appData,
    detectedDialect: !isSupportedLanguageCode(i18n.language)
      ? i18n.languages
      : undefined,
  };
};
